/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateRemoteSessionClientForm,
  UpdateRemoteSessionClientForm$Outbound,
  UpdateRemoteSessionClientForm$outboundSchema,
} from "../components/updateremotesessionclientform.js";

export type UpdateOrganizationRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type UpdateOrganizationRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  updateRemoteSessionClientForm: UpdateRemoteSessionClientForm;
};

/** @internal */
export type UpdateOrganizationRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const UpdateOrganizationRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    UpdateOrganizationRemoteSessionClientSecurity$Outbound,
    UpdateOrganizationRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function updateOrganizationRemoteSessionClientSecurityToJSON(
  updateOrganizationRemoteSessionClientSecurity:
    UpdateOrganizationRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    UpdateOrganizationRemoteSessionClientSecurity$outboundSchema.parse(
      updateOrganizationRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type UpdateOrganizationRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  UpdateRemoteSessionClientForm: UpdateRemoteSessionClientForm$Outbound;
};

/** @internal */
export const UpdateOrganizationRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    UpdateOrganizationRemoteSessionClientRequest$Outbound,
    UpdateOrganizationRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      updateRemoteSessionClientForm:
        UpdateRemoteSessionClientForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        updateRemoteSessionClientForm: "UpdateRemoteSessionClientForm",
      });
    }),
  );

export function updateOrganizationRemoteSessionClientRequestToJSON(
  updateOrganizationRemoteSessionClientRequest:
    UpdateOrganizationRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    UpdateOrganizationRemoteSessionClientRequest$outboundSchema.parse(
      updateOrganizationRemoteSessionClientRequest,
    ),
  );
}
